// THE canonical day boundary for FragranceOS. Import from here — never re-implement.
//
// Why this file exists (2026-07-27): `todayISO()` was implemented twice, in
// homeNav.js (read path) and wearLogContext.js (write path), and BOTH used
// `new Date().toISOString().split('T')[0]` — which is UTC. For any user west of
// UTC that makes "today" roll over before midnight local: at 9:21 PM ET the UTC
// date is already tomorrow. Consequences observed in production:
//   - a SOTD logged after ~8 PM ET vanished from Home the moment it was saved
//     (founder ticket 5a472197, reproduced twice)
//   - the "Reapply" control disappeared from an active wear
//   - the day-scoped wear list read empty while the row existed server-side
//
// Every wear_logs row in production is dated by LOCAL calendar day (verified
// 2026-07-27: 14/14 rows matched America/New_York, including a row written at
// 01:21 UTC that is correctly stored as the previous local day). The stored data
// was always local; only these helpers disagreed. So local is the correct and
// non-breaking definition — no backfill is required.
//
// Do not "simplify" any of this back to toISOString(): that function is defined
// to emit UTC, which is exactly the defect.

/** Local calendar day as YYYY-MM-DD. Never UTC. */
export function localDayISO(date = new Date()) {
  const value = date instanceof Date ? date : new Date(date)
  if (Number.isNaN(value.getTime())) return ''
  const year = value.getFullYear()
  const month = String(value.getMonth() + 1).padStart(2, '0')
  const day = String(value.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/** Local day N days back (negative = future). */
export function shiftLocalDayISO(days, from = new Date()) {
  const value = new Date(from)
  value.setDate(value.getDate() - days)
  return localDayISO(value)
}

/**
 * Value for an <input type="datetime-local">, in local wall-clock time.
 * Kept here so the four copies that existed across components share one
 * definition with the day boundary they have to agree with.
 */
export function localDateTimeValue(input = new Date()) {
  const value = input instanceof Date ? input : new Date(input)
  if (Number.isNaN(value.getTime())) return ''
  return `${localDayISO(value)}T${String(value.getHours()).padStart(2, '0')}:${String(value.getMinutes()).padStart(2, '0')}`
}

/** True when the two instants fall on the same local calendar day. */
export function isSameLocalDay(a, b) {
  const first = a instanceof Date ? a : new Date(a)
  const second = b instanceof Date ? b : new Date(b)
  if (Number.isNaN(first.getTime()) || Number.isNaN(second.getTime())) return false
  return localDayISO(first) === localDayISO(second)
}
